<template>
	<div class="">
		<canvas :id="'chart-' + _uid"></canvas>
	</div>
</template>

<script>
	import Chart from 'chart.js';

	export default {
		components:{

		},

		props:[
			'graph_data',
			'subtitle_1',
			'subtitle_2',
			'disable_duration'
		],

		data(){
			return {
				to_update: false
			}
		},

		mounted() {
			this.loadGraph();
		},

		methods: {
			loadGraph(){
				let
					ctx = document.getElementById('chart-' + this._uid).getContext('2d'),
					dataset = null,
					data = [],
					data_prev = [],
					labels = [];


				ctx.webkitImageSmoothingEnabled = false;
				ctx.mozImageSmoothingEnabled = false;
				ctx.imageSmoothingEnabled = false;

				if (typeof (this.graph_data) === 'undefined' || !this.graph_data){
					return;
				}

				for (const group in this.graph_data){
					if (this.graph_data.hasOwnProperty(group)) {
						if (this.graph_data[group] !== null){
							data.push(this.graph_data[group].score_percentage);
							data_prev.push(this.graph_data[group].avg_score_percentage);
							labels.push(group);
						}
					}
				}

				dataset = {
					labels: labels,
					datasets: [
						{
							backgroundColor: '#820E3DB3',
							borderWidth: 0,
							data: data,
							pointRadius : 1,
							label: this.subtitle_1
						},
						{
							backgroundColor: '#B08F30B3',
							borderWidth: 0,
							data: data_prev,
							pointRadius : 1,
							label: this.subtitle_2
						},
					]
				};

				new Chart(ctx, {
					type: 'radar',
					data: dataset,
					plugins: [this.createChartPlugin()],
					options: {
						maintainAspectRatio: false,
						legend: {
							display: true,
							position: 'bottom',
							labels: {
								boxWidth: 15
							}
						},
						animation: {
							duration: this.disable_duration ? 0 : 1000
						},
						startAngle: -30,
						scale: {
							ticks: {
								display: false,
								beginAtZero: true,
								stepSize: 10,
								max: 100
							},
							scale: {
								display: false
							},
							angleLines:{
								display: false
							},
						},
					}
				});
			},

			createChartPlugin(){
				let _this = this;

				return {
					id: 'export_png_data',

					beforeDraw : function(chart, options){
						if (_this.to_update)
							return;

						_this.$emit('update_graph_image', null);
						_this.to_update = true;
					},

					afterRender: function(chart, options) {
						if (!_this.to_update)
							return;
						if (document.getElementById('chart-' + _this._uid)){
							_this.$emit('update_graph_image', document.getElementById('chart-' + _this._uid).toDataURL('image/png', 0.2));
							_this.to_update = false;
						}
					}
				};
			},
		},

		watch: {
			graph_data(){
				this.loadGraph();
			}
		}
	}
</script>
